import { GameReelsProperties } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/properties/GameReelsProperties";
/**
 * ReelsLandscapeProperties.ts
 */
export class ReelsLandscapeProperties extends GameReelsProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.scale.set(0.726);
        this.position.set(629, 749);
        this.freeSpinsBackgroundProperties.scale.set(1 / 0.726);
        this.freeSpinsBackgroundProperties.position.set(470, -342);
    }
    equals(other) {
        return false;
    }
}
